import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-sidebar',
  templateUrl: './help-sidebar.component.html',
  styleUrls: ['./help-sidebar.component.scss']
})
export class HelpSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
